// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_102mm_99mm_1_label_per_page_layout__353KV"};